import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { Container, Row, Col } from "react-grid-system";

const ExampleApps = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "Example Apps", url: "/example-apps" },
            ]}
          />
          <h1>Example Apps</h1>
          <p>
            Blues provides a variety of open source example applications, code 
            snippets, and best practices to help you build your connected 
            product.
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="landing-page-link-list">
            <div>
              <img alt="" src={ImgSrc("/images/icons/docs/notecard-solutions.svg")} />
              <h4>Accelerators</h4>
              <p>
                Fully documented open source reference applications for 
                assembling Notecard- and Notehub-powered solutions.
              </p>
              <TrackedLink
                href="/accelerators"
                className="landingLink"
              >
                View the accelerators
              </TrackedLink>
            </div>

            <div>
              <img alt="" src={ImgSrc("/images/icons/docs/firmware-libraries.svg")} />
              <h4>SDK Examples</h4>
              <p>
                SDK-specific code examples to help you get started with 
                note-arduino and note-python.
              </p>
              <TrackedLink
                href="/example-apps/sdk-examples"
                className="landingLink"
              >
                View the SDK examples
              </TrackedLink>
            </div>

            </div>
          </Col>
          </Row>

          <Row>
            <Col>
            <div className="landing-page-link-list">
            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/reference.svg")}
              />
              <h4>Sample Apps</h4>
              <p>
                Purpose-built sample applications that address specific 
                capabilities of the Notecard and Notehub.
              </p>
              <TrackedLink
                href="/example-apps/sample-apps"
                className="landingLink"
              >
                View the sample apps
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/precision-manufacturing.svg")}
              />
              <h4>Community Projects</h4>
              <p>
                Community-created project showcases built around the Notecard 
                and featured on Hackster.
              </p>
              <TrackedLink
                href="/community/projects"
                className="landingLink"
              >
                View the projects
              </TrackedLink>
            </div>

          </div>
        </Col>
      </Row>
    </Container>
  </>
);

export default ExampleApps;
